import {unplannedNotifictaionService} from "./unplannedNotification-service";
import CustomerRepository from '@/repository/customerRepository';
import {isNotFirstVisit} from "../visitCounter";

const customerRepository = new CustomerRepository();
const mq = window.matchMedia('(max-width: 740px)');
const isMobile = mq.matches;

export const accountService = {
    initializeUser: async () => {
        let userData = {
            cartLineCount: 0,
            isLogged: false,
            user_name: '',
            email: '',
            accountMenu: '',
        };

        // optimization to doesn't send request if user/bot visiting page for the first time
        if (isNotFirstVisit()) {
            userData = await customerRepository.getCustomerData();
        }

        window.isLoggedUser = userData.isLogged;
        accountService.fillOutUserHeader(userData);
        accountService.checkOpenAccountMenu(userData.isLogged)
    },

    checkOpenAccountMenu: (isLoggedUser) => {
        if (isLoggedUser) {
            unplannedNotifictaionService.showUnplannedNotification();
        }

        (isMobile && window.shouldOpenMenu) && accountService.accountControlOnClick();
    },
    accountControlOnClick: () => {
        const $accountMenu = $('.js_account-menu');

        if (!window.isLoggedUser) {
            window.location.href = `${window.env.baseUrl}/?action=auth/login`;
            return;
        }

        $('.js_account-header').toggleClass('is-active');
        $accountMenu.toggleClass('is-active');
        $('.js_overlay-show-account').toggleClass('is-active');

        if ($accountMenu.hasClass('is-active')) {
            const $header = $('#header');
            setTimeout(() => {
                const headerVisibleHeight = $header.height() + $header.position().top;

                $('#accountMenuDropdown').css(isMobile ? 'height' : 'max-height', `calc(100vh - ${headerVisibleHeight}px)`);
            }, 0);
        }
    },

    fillOutUserHeader: (userData) => {
        const $userName = $('.accountHeader').find('.js_user-name');

        if (!userData) return;

        let cartLineCount = +userData.cartLineCount;
        $('div.cart .quantity').text(cartLineCount);

        if (!userData.isLogged) {
            $userName.text('Inloggen');
            return;
        }

        $userName.text(userData.user_name);
        $('.js_account-menu-block').append(userData.accountMenu);
        $('.js_user-name').val(userData.user_name);
        $('.js_user-email').val(userData.email);
        $('.js_add-wishlist').removeClass('hidden');
        accountService.fillOutSearchPlaceholder(userData.user_name);
    },

    fillOutSearchPlaceholder: (userName) => {
        let fcSearch = $('#fc_search');
        let customerPlaceholder = fcSearch.data('customerplaceholder');
        let placeholder = userName + customerPlaceholder;

        fcSearch.attr("placeholder", placeholder);
    },
}
